import React, { useState, useEffect } from "react";
import {
  FaTimes,
  FaEnvelope,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa6";
import { CgMenuRightAlt } from "react-icons/cg";
import Icard from "../Icard/Icard";
import { BiSolidPhoneCall } from "react-icons/bi";
import "../Header/Header.css";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isIcardOpen, setIsIcardOpen] = useState(false);
  const [isTopBarVisible, setTopBarVisible] = useState(true);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setTopBarVisible(false);
      } else if (currentScrollY < lastScrollY || currentScrollY <= 50) {
        setTopBarVisible(true);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const openIcard = () => {
    setIsIcardOpen(true);
  };

  const closeIcard = () => {
    setIsIcardOpen(false);
  };

  const handleCallNow = () => {
    window.location.href = "tel:+919555768358";
  };
  const openWhatsapp = () => {
    const whatsappUrl =
      "https://api.whatsapp.com/send/?phone=%2B919555768358&text&type=phone_number&app_absent=0";
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };
  const handleMailToClick = () => {
    const mailtoLink = `mailto:care@panoasis.in`;
    window.location.href = mailtoLink;
  };
  return (
    <div className="full-header">
      {isIcardOpen && <Icard onClose={closeIcard} />}
      <div
        className={`header ${isTopBarVisible ? "top-bar-visible" : "top-bar-hidden"}`}
      >
        {/* Top Bar */}
        {isTopBarVisible && (
          <div className="top-bar">
            {/*--
            <p className="top-text">RERA ID: UPRERAPRJ5667</p>
            --*/}
            <div className="top-first">
              <div>
                <FaMapMarkerAlt /> Sector-70, Central Noida, Uttar Pradesh,
                India
              </div>
            </div>
            <div className="top-last">
              <div onClick={handleMailToClick}>
                <FaEnvelope /> care@panoasis.in
              </div>
              <div onClick={openWhatsapp}>
                <FaWhatsapp /> WhatsApp Now
              </div>
            </div>
          </div>
        )}

        {/* Main Header */}
        <div className="main-header">
          <Link to="/">
            <img src="/logo.webp" className="logo1" alt="logo" />
          </Link>

          {/* Desktop Navigation Links */}
          <nav className={`nav-links ${isMenuOpen ? "show-menu" : ""}`}>
            <Link to="/">Home</Link>
            <Link to="/aboutus">About</Link>
            <Link to="/layouts">Layouts</Link>
            <Link to="#" onClick={openIcard}>
              Brochure
            </Link>
            <Link to="/pricelist">Price List</Link>
            <Link to="/contactus">Contact</Link>
          </nav>

          {/* Hamburger Menu */}
          <div className="hamburger-menu" onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes /> : <CgMenuRightAlt />}
          </div>

          <div className="last">
            <button onClick={handleCallNow} className="book-meeting">
              <BiSolidPhoneCall /> +91 9555768358
            </button>
          </div>
        </div>
      </div>

      {/* Slider Menu for Mobile */}
      {isMenuOpen && (
        <div className="menu-slider">
          <p>Welcome to Pan Oasis, The New standard of ultra luxury</p>
          <nav className="mobile-nav-links">
            <Link to="/" onClick={toggleMenu}>
              Home
            </Link>
            <Link to="/aboutus" onClick={toggleMenu}>
              About
            </Link>
            <Link to="/layouts" onClick={toggleMenu}>
              Layouts
            </Link>
            <Link to="#" onClick={openIcard}>
              Brochure
            </Link>
            <Link to="/pricelist" onClick={toggleMenu}>
              Price List
            </Link>
            <Link to="/contactus" onClick={toggleMenu}>
              Contact
            </Link>
          </nav>
          <div className="m-last">
            <Link to="/contactus">
              <button className="book-meeting">
                <BiSolidPhoneCall /> +91 000000000
              </button>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
